import { render, staticRenderFns } from "./EbookCardDownloadLink.vue?vue&type=template&id=8975e6b2&"
import script from "./EbookCardDownloadLink.vue?vue&type=script&lang=js&"
export * from "./EbookCardDownloadLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports